import React, { useState } from "react";
import { UserRole } from "./UserRole";
import { CreatePermissionRole } from "./UserRole/CreatePermissionRole";
import { EditPermissionRole } from "./UserRole/EditPermissionRole";
import { UserGroup } from "./UserGroup";
import { showToast } from "services/utils/Status";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { CreateUserGroup } from "./UserGroup/CreateUserGroup";
import { EditUserGroup } from "./UserGroup/EditUserGroup";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { CustomButton } from "components/CustomComponents";
import { rowEndStyle } from "services/constants/Styles";
export const RoleAndUserGroup = () => {
  const [screenNavigation, setScreenNavigation] = useState("");
  const [selectedComponent, setSelectedComponent] = useState("Roles");
  const { userScreenAccess } = useSelector((state) => state.tokenReducer);
  // const [showCreateRole, setShowCreateRole] = useState(false);
  const [editRoleDetails, setEditRowDetails] = useState([]);
  const [productRolesDetails, setProductRolesDetails] = useState([]);
  const [editUserGroupDetails, setEditUserGroupDetails] = useState([]);
  const dispatch = useDispatch();
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Roles & User Group",
    "Roles"
  );
  const showCreateRoleScreen = () => {
    setScreenNavigation("Create Role");
  };

  const showCreateUserGroup = () => {
    setScreenNavigation("Create User Group");
  };

  const handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setSelectedComponent(newAlignment);
      dispatch(setGlobalSearchValue(""));
    }
  };

  const renderComponents = () => {
    switch (screenNavigation) {
      case "Create Role":
        return (
          <CreatePermissionRole
            setScreenNavigation={setScreenNavigation}
            productRolesDetails={productRolesDetails}
            setProductRolesDetails={setProductRolesDetails}
          />
        );
      case "Edit Role":
        return (
          <EditPermissionRole
            setScreenNavigation={setScreenNavigation}
            editRoleDetails={editRoleDetails}
          />
        );
      case "Create User Group":
        return <CreateUserGroup setScreenNavigation={setScreenNavigation} />;
      case "Edit User Group":
        return (
          <EditUserGroup
            setScreenNavigation={setScreenNavigation}
            editUserGroupDetails={editUserGroupDetails}
          />
        );

      default:
        break;
    }
  };

  return screenNavigation === "Create Role" ||
    screenNavigation === "Create User Group" ||
    screenNavigation === "Edit Role" ||
    screenNavigation === "Edit User Group" ? (
    <Mui.Grid container>{renderComponents()}</Mui.Grid>
  ) : (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 1.5 }}>
        <Mui.Grid xs={8}>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: 3,
              height: 45,
              width: 250,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Mui.ToggleButtonGroup
              value={selectedComponent}
              exclusive
              onChange={handleChange}
              sx={{
                display: "flex",
                width: "100%",
                height: "100%",
                position: "absolute",
                borderRadius: 3,
                backgroundColor: themes.lightBrown,
              }}
            >
              <Mui.ToggleButton
                value="Roles"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  fontWeight: 600,
                  border: "none",
                  color:
                    selectedComponent === "Roles"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    selectedComponent === "Roles"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      selectedComponent === "Roles"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      selectedComponent === "Roles"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  dispatch(setGlobalSearchValue(""));
                  setSelectedComponent("Roles");
                }}
              >
                <Mui.Typography style={{ fontWeight: "bold", fontSize: 15 }}>
                  Roles
                </Mui.Typography>
              </Mui.ToggleButton>
              <Mui.ToggleButton
                value="User Group"
                sx={{
                  width: "200px",
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  fontWeight: 600,
                  border: "none",
                  color:
                    selectedComponent === "User Group"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    selectedComponent === "User Group"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      selectedComponent === "User Group"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      selectedComponent === "User Group"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  dispatch(setGlobalSearchValue(""));
                  setSelectedComponent("User Group");
                }}
              >
                <Mui.Typography style={{ fontWeight: "bold", fontSize: 15 }}>
                  User Group
                </Mui.Typography>
              </Mui.ToggleButton>
            </Mui.ToggleButtonGroup>
          </Mui.Box>
        </Mui.Grid>
        <Mui.Grid xs={4} sx={{ ...rowEndStyle, paddingRight: 1 }}>
          {selectedComponent === "User Group" ? (
            <CustomButton
              actionFuntion={() => {
                if (check_access) {
                  showCreateUserGroup();
                } else {
                  showToast(
                    "error",
                    "Access denied: You are not authorized to create user group"
                  );
                }
              }}
              actionName="Create User Group"
              typeName="button"
            />
          ) : (
            <CustomButton
              actionFuntion={() => {
                if (
                  checkEditorPermission(
                    userScreenAccess?.module_details,
                    "Roles & User Group",
                    "User Group"
                  )
                ) {
                  showCreateRoleScreen();
                } else {
                  showToast(
                    "error",
                    "Access denied: You are not authorized to create user group"
                  );
                }
              }}
              actionName="Create Role"
              typeName="button"
            />
          )}
        </Mui.Grid>
      </Mui.Grid>
      {selectedComponent === "User Group" ? (
        <Mui.Grid container>
          <UserGroup
            setScreenNavigation={setScreenNavigation}
            setEditUserGroupDetails={setEditUserGroupDetails}
          />
        </Mui.Grid>
      ) : (
        <Mui.Grid container>
          <UserRole
            setScreenNavigation={setScreenNavigation}
            setEditRowDetails={setEditRowDetails}
          />
        </Mui.Grid>
      )}
    </React.Fragment>
  );
};
